import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { useLocalStorage } from "@uidotdev/usehooks";
import { Link } from "react-router-dom";

const CloudConnectivity = () => {
  const [storedName] = useLocalStorage("name", null);
  const { brandData, loading, errors } = useTraceabilityData();
  const brandName = brandData?.logo?.brandName || "[Brand Name]";

  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Cloud Connectivity</h2>
      </div>

      {/* Intro Section */}
      <section className="py-0">
        <div className="container p-3">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
             
                <div className="product-item col">
                  <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                    <img src="img/smartfarm.png" alt="" className="card-img-top" />
                  </div>
                </div>

              <div className="card-text text-muted py-1 px-1" style={{ marginLeft: "20px", fontSize: "12px" }}>
                {loading.brand && <p>Loading brand information...</p>}
                {!loading.brand && errors.brand && <p>Error loading brand information.</p>}
                {!loading.brand && !errors.brand && (
                  <p>
                    Technology is at the heart of the way we work, and our cloud-connected systems are leading the charge in revolutionizing dairy operations. By digitizing every step, we enable precision, transparency, and seamless quality control, making the entire process smarter and more efficient.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Connectivity Technologies */}
      <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Our Connectivity Technologies:</h6>
          <br />

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-2 g-3">

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list" style={{ border: "0px" }}>
                <img src="img/Cloud-Connectivity_-min.png" alt="" className="card-img-top" />
                <h6 className="fw-normal" style={{ fontSize: "11px", textAlign: "left", paddingTop: "10px", color: "black" }}>
                  <b>smartAMCU</b>
                </h6>
                <p style={{ color: "black" }}>IoT-Based Real-Time Data for Milk Collection</p>
              </div>
            </div>

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list" style={{ border: "0px" }}>
                <img src="img/smartCC_-min.png" alt="" className="card-img-top" />
                <h6 className="fw-normal" style={{ fontSize: "11px", textAlign: "left", paddingTop: "10px", color: "black" }}>
                  <b>smartCC</b>
                </h6>
                <p style={{ color: "black" }}>IoT-Based Automation for Chillers</p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/sustainability-in-milk-grading"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/quality-check"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>

      {/* <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Milk Grading Insights */}
      {/* <div className="bg-light">
        <div className="container p-3">
          <h6 className="card-title fw-bold my-2">Milk Grading Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <a href="technology-driven-quality-tests">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-45.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      Technology-Driven<br /> Quality Checks
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="empowering-farmers-and-communities">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-46.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "14px" }}>
                      Empowering Farmers & Communities
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="sustainability-in-milk-grading">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-47.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>
                      Sustainability in Milk Grading
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="cloud-connectivity">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/Asset-48.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ top: "30%" }}>
                    <h6 className="fw-normal" style={{ fontSize: "15px" }}>Cloud Connectivity</h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="container p-3">
        <div className="underline2"></div>
      </div> */}

      {/* Traceability Journey */}
      {/* <div className="wrapper2">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div>

      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />
            <ProductItem
              href="milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />
            <ProductItem
              href="quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />
            <ProductItem
              href="manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />
            <ProductItem
              href="distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />
            <ProductItem
              href="it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName || "You"}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default CloudConnectivity;

